import { Route } from "react-router-dom";
import { Routes } from "@datadog/browser-rum-react/react-router-v7";
import AuthCallback from "../components/templates/auth/AuthCallback";
import SilentRenew from "../components/templates/auth/SilentRenew";
import SignedOut from "../components/templates/auth/SignedOut";
import ClientsPage from "../components/templates/client/ClientsPage";
import OldSntWireframedTemplate from "../components/templates/OldSntWireframedTemplate";
import DocumentHandler from "../components/templates/DocumentHandler";
import ProtectedRoute from "../auth/ProtectedRoute";
import ProtectedLayout from "./ProtectedRoutesLayout";
import AmlMonitoringEvents from "../components/templates/aml/AmlMonitoringEvents";
import AmlRiskScores from "../components/templates/aml/AmlRiskScores";
import UnauthorizedPage from "../components/molecules/UnauthorizedPage";
import EditTemplatePage from "../components/templates/EditTemplatePage";
import HomePage from "../components/templates/HomePage";
import InvoiceValidationDetailedPage from "../components/templates/invoices/InvocieValidationDetailedPage";
import InvoiceAssessmentDetailedPage from "../components/templates/invoices/InvoiceAssessmentDetailedPage";
import InvoicesListPage from "../components/templates/invoices/InvoicesListPage";
import NotFoundPage from "../components/templates/NotFoundPage";
import InvoiceOverviewPage from "../components/templates/invoices/InvoiceOverviewPage";
import UserManagmentPage from "../components/templates/users/UserManagmentPage";
import GroupDetailPage from "../components/templates/users/GroupDetailPage";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/callback" element={<AuthCallback />} />
      <Route path="/silent" element={<SilentRenew />} />
      <Route path="/signed-out" element={<SignedOut />} />
      <Route path="/unauthorized" element={<UnauthorizedPage />} />

      <Route
        element={
          <ProtectedRoute>
            <ProtectedLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<HomePage />} />
        <Route path="client" element={<ClientsPage />} />
        <Route
          path="client/:id"
          element={<OldSntWireframedTemplate path="client" />}
        />
        <Route
          path="client/:id/aml"
          element={<OldSntWireframedTemplate path="clientAml" />}
        />
        <Route
          path="client/:id/invoicesNew"
          element={<OldSntWireframedTemplate path="invoicesNew" />}
        />
        <Route
          path="client/:id/files"
          element={
            <OldSntWireframedTemplate path="documentAgreementsSecurities" />
          }
        />
        <Route
          path="client/:id/invoicesNew/:tab"
          element={<OldSntWireframedTemplate path="invoicesNew" />}
        />
        <Route
          path="client/:id/templates"
          element={<OldSntWireframedTemplate path="clientTemplates" />}
        />
        <Route
          path="client/document"
          element={<OldSntWireframedTemplate path="document" />}
        />
        <Route
          path="client/:id/invoices/templates"
          element={<OldSntWireframedTemplate path="clientTemplates" />}
        />
        <Route
          path="client/:id/invoices/templates/edit/:templateId"
          element={<EditTemplatePage />}
        />
        <Route
          path="interpretationResult/client/:id/:objectsAsBase64"
          element={<OldSntWireframedTemplate path="interpretation-result" />}
        />
        <Route
          path="person"
          element={<OldSntWireframedTemplate path="person" />}
        />
        <Route
          path="invoices"
          element={<OldSntWireframedTemplate path="invoices" />}
        />
        <Route
          path="invoices-edit"
          element={<OldSntWireframedTemplate path="invoices-edit" />}
        />
        <Route
          path="rule-buckets"
          element={<OldSntWireframedTemplate path="rule-buckets" />}
        />
        <Route
          path="tolkien"
          element={<OldSntWireframedTemplate path="tolkien" />}
        />
        <Route
          path="rating"
          element={<OldSntWireframedTemplate path="rating" />}
        />
        <Route
          path="prospect"
          element={<OldSntWireframedTemplate path="prospect" />}
        />
        <Route
          path="onboardings"
          element={<OldSntWireframedTemplate path="onboardings" />}
        />
        <Route
          path="agreements"
          element={<OldSntWireframedTemplate path="agreements" />}
        />
        <Route
          path="monitoring-triggers"
          element={<OldSntWireframedTemplate path="monitoring-triggers" />}
        />
        <Route
          path="blacklist"
          element={<OldSntWireframedTemplate path="blacklist" />}
        />
        <Route path="kyc" element={<OldSntWireframedTemplate path="kyc" />} />
        <Route
          path="batchdetermination"
          element={<OldSntWireframedTemplate path="batchdetermination" />}
        />
        <Route path="aml-monitor-overview" element={<AmlMonitoringEvents />} />
        <Route path="aml-risk-overview" element={<AmlRiskScores />} />
        <Route
          path="settings"
          element={<OldSntWireframedTemplate path="settings" />}
        />
        <Route path="document-handler" element={<DocumentHandler />} />
        <Route path="invoices/:page" element={<InvoicesListPage />} />
        <Route
          path="invoices/validate/:id/:clientIdentifier"
          element={<InvoiceValidationDetailedPage />}
        />
        <Route
          path="invoices/assess/:clientIdentifier/:invoiceId?"
          element={<InvoiceAssessmentDetailedPage />}
        />
        <Route
          path="invoices/overview/:id/:clientIdentifier"
          element={<InvoiceOverviewPage />}
        />

        <Route path="users" element={<UserManagmentPage />} />
        <Route path="groups" element={<UserManagmentPage />} />
        <Route path="groups/:groupId" element={<GroupDetailPage />} />

        {/* Default fallback */}
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
